import { stockIntegritySummary } from '../inventoryView';
import type { InventoryScreenRow } from '../inventoryView';
import { locationStock } from '../locationStock';

export interface LocationStockCardProps {
  rows: InventoryScreenRow[];
  locationCode: string;
  complete: boolean;
}

/** A read-only physical tally: Reserved is part of On Hand, not extra units. */
export function LocationStockCard({ rows, locationCode, complete }: LocationStockCardProps) {
  const stock = locationStock(rows, locationCode);
  const issues = stockIntegritySummary(stock.rows);
  const dispatchRestricted = stock.rows.some((row) => row.available !== row.onHand - row.reserved);
  return (
    <section className="card loc-stock" aria-label={`Stock at ${locationCode}`}>
      <h4>
        Stock at <span className="loc-pill">{locationCode}</span>
      </h4>
      <div className="bigrow">
        <div className="bignum">
          <div className="n">{stock.rows.length}</div>
          <div className="l">SKUs</div>
        </div>
        <div className="bignum">
          <div className="n">{stock.onHand}</div>
          <div className="l">On Hand (physical)</div>
        </div>
        <div className="bignum">
          <div className="n res">{stock.reserved}</div>
          <div className="l">Reserved (part of On Hand)</div>
        </div>
        <div className="bignum">
          <div className={`n ${stock.available < 0 ? 'text-danger' : 'av'}`}>{stock.available}</div>
          <div className="l">Available</div>
        </div>
      </div>
      <p className="loc-stock-note">
        Totals cover this location with the current filters. On Hand is the physical quantity; Reserved is already
        inside it. Available = On Hand − Reserved, never subtracting reservations twice.
      </p>
      {!complete && <p className="loc-stock-note">Partial results - totals may be incomplete.</p>}
      {dispatchRestricted && (
        <p className="loc-stock-note">
          Physical Available here differs from the table&apos;s server-reported Available: dispatch restrictions can
          prevent stock at virtual or non-pickable locations from being offered.
        </p>
      )}
      {issues && (
        <div role="status" className="note warn">
          {`This location does not add up: ${issues}.`}
        </div>
      )}
    </section>
  );
}
